// extracted by mini-css-extract-plugin
export var wrapper = "registration-module--wrapper--tJj6S";
export var slider = "registration-module--slider--aDCFl";
export var slideInner = "registration-module--slideInner--Hp7Ff";
export var slideMore = "registration-module--slideMore--1-NoG";
export var slideTitle = "registration-module--slideTitle--RxunC";
export var slideContent = "registration-module--slideContent--GqmfO";
export var imgWrapper = "registration-module--imgWrapper--j4r-0";
export var imgContent = "registration-module--imgContent--7BeqU";
export var flag = "registration-module--flag--4CzOH";